import React from 'react';
import '../../App.css';
import Navbar from '../../components/Navbar';
import SignUpForm from '../SignUpForm';

const Signup = () => {
  return (
    <div>
      <Navbar />
      <SignUpForm />
    </div>
  );
}

export default Signup;